import { styled } from 'baseui';
import { borderColor, borderWidth, marginSize, paddingSize, borderStyle } from '../../Utilities/utils/Theming';
import { ISmartProps } from './types';
import {
	ALL_STYLES,
	State,
	FormState,
	PseudoState,
	CheckBoxFontSize,
	CheckBoxLineHeight,
	CaptionFontSize,
	CaptionLineHeight,
} from '../Checkbox/styles';
import { focusRing } from '../../Themes/base/focusRing';

interface ICheckboxIcon {
	children: any;
	className: string;
}

export const RadioIcon = styled<ICheckboxIcon, 'i', any>('i', ({ $theme }) => {
	return {
		color: 'var(--epods--color-text-inverted)',
		fontSize: 'var(--epods--checkbox-size-base)',
		verticalAlign: '0',
	};
});

export const RadioRoot = ($theme: any) => {
	return {
		alignItems: 'center',
		...marginSize('0', '2px', '0', '2px'),
		...paddingSize('0', '0', '0', '0'),
		position: 'relative' as any,
	};
};

export const RadioLabel = ($theme: any, $disabled: boolean, props: ISmartProps) => {
	return {
		paddingLeft: 'var(--epods--space-inset-s)',
		alignItems: 'center',
		overflow: 'hidden',
		whiteSpace: 'nowrap' as 'nowrap',
		textOverflow: 'ellipsis',

		lineHeight: CheckBoxLineHeight[props.size || 'default'],
		fontFamily: 'var(--epods--font-base)',
		fontSize: CheckBoxFontSize[props.size || 'default'],
		marginRight: 'var(--epods--checkbox-label-horizontal-padding)',

		color: $disabled ? 'var(--epods--color-text-disabled)' : 'var(--epods--checkbox-label-color)',
	};
};

export const RadioDescription = (size: any) => {
	return {
		maxWidth: 'none',
		marginLeft: 'var(--epods--checkbox-caption-margin)',
		marginBottom: 'var(--epods--space-inset-s)',
		alignItems: 'center',
		lineHeight: CaptionLineHeight[size || 'default'],
		fontFamily: 'var(--epods--font-base)',
		fontSize: CaptionFontSize[size || 'default'],
		color: 'var(--epods--checkbox-caption-color)',
	};
};

export const RadioInput = ($theme: any, props: ISmartProps) => {
	const marginBottom = props.description
		? {}
		: {
				marginTop: '0',
				marginRight: '0',
				marginBottom: 'var(--epods--space-inset-s)',
				marginLeft: '0',
		  }; // TODO: create new variable
	return {
		cursor: !props.disabled ? 'pointer' : 'not-allowed',
		height: 'var(--epods--checkbox-size-base)',
		width: 'var(--epods--checkbox-size-base)',
		...marginBottom,
	};
};

/**
 * Outter dot color control
 */
export const RadioCheckmark = (
	$theme: any,
	$isFocused: boolean,
	$isHovered: boolean,
	$isActive: boolean,
	$disabled: boolean,
	$checked: boolean,
	$isIndeterminate: boolean,
	props: ISmartProps,
) => {
	const state = $checked ? State.CHECKED : State.UNCHECKED;
	const formState = props.error ? FormState.ERROR : FormState.DEFAULT;
	const pseudoState = $disabled ? PseudoState.DISABLED : $isHovered ? PseudoState.HOVER : PseudoState.DEFAULT;

	const styles = ALL_STYLES[state][formState][pseudoState];

	return {
		...marginSize('0', '0', '0', '0'),
		height: 'var(--epods--checkbox-size-base)',
		width: 'var(--epods--checkbox-size-base)',
		...borderStyle('solid'),
		...borderWidth('1px'),
		...borderColor('transparent'),
		...styles,
		...(props.error
			? {
					'--epods--color-bg-primary': 'var(--epods--color-bg-toggle-error)',
			  }
			: {}),
		...($isFocused ? focusRing : {}),
	};
};

export const RadioCheckmarkInner = ($theme: any, $disabled: boolean, $checked: boolean) => {
	return $disabled
		? $checked
			? { backgroundColor: 'var(--epods--color-text-inverted)' }
			: { backgroundColor: 'var(--epods--color-bg-inactive-boxes-disabled)' }
		: $checked
		? { backgroundColor: 'var(--epods--color-text-inverted)' }
		: { backgroundColor: '--epods--checkbox-tickFill' };
};
